import { QueryClient } from '@tanstack/vue-query'

/**
 * Konfigurasi default TanStack Query untuk seluruh app.
 * staleTime cukup panjang agar tidak refetch berlebihan pada data dashboard.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 1000 * 60, // 1 menit dianggap fresh
        gcTime: 1000 * 60 * 10, // 10 menit di cache
        retry: 1,
        refetchOnWindowFocus: false,
      },
    },
  })
}
